import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export const TicketsSkeleton = () => {
  return (
    <Paper sx={{ my: 3 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 16 }} />
              <TableCell colSpan={2}>
                <Skeleton variant="text" width={50} animation="wave" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array(10)
              .fill(null)
              .map((_, index) => {
                return (
                  <TableRow key={index} sx={{ height: 86 }}>
                    <TableCell sx={{ width: 16 }} />
                    <TableCell>
                      <Skeleton variant="text" width={"70%"} animation="wave" />
                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        <Skeleton
                          variant="rounded"
                          width={180}
                          animation="wave"
                        />
                        <Skeleton
                          variant="rounded"
                          width={80}
                          animation="wave"
                        />
                      </Stack>
                    </TableCell>
                    <TableCell sx={{ width: "25%" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "right",
                          pr: 4,
                        }}
                      >
                        <Skeleton
                          variant="rectangular"
                          height={8}
                          width={"75%"}
                          animation="wave"
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
